module.exports = __webpack_public_path__ + "img/tree-deciduous.9e1c04bf.svg";